import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { todoApi } from '../services/api';
import { CreateToDoItem } from '../types/api';

export const TODOS_KEY = ['todos'] as const;

export const useTodos = () =>
  useQuery({ queryKey: TODOS_KEY, queryFn: todoApi.getAll });

export const useCreateTodo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (todo: CreateToDoItem) => todoApi.create(todo),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TODOS_KEY }),
  });
};

export const useUpdateTodo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<CreateToDoItem> }) =>
      todoApi.update(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TODOS_KEY }),
  });
};

export const useDeleteTodo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => todoApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TODOS_KEY }),
  });
};
